'use client';

import React, { useContext } from 'react';
import { SimpleBlockContext } from './SimpleBlockContext';
import { Text } from '../Text';
import { HeadingContainer } from './elements';
import { DefaultsProvider } from '../../util';
export const Heading = ({
  size,
  weight = 'heavy',
  children,
  headingLevel,
  ...props
}) => {
  const {
    size: blockSize
  } = useContext(SimpleBlockContext);
  const fontSize = {
    sm: 2,
    md: 4,
    lg: 5,
    xl: 6
  };
  const lineHeight = {
    sm: 1.3,
    md: 1.3,
    lg: 1.2,
    xl: 1.15
  }[blockSize];
  const tagSize = {
    sm: 'small',
    md: 'small',
    lg: 'regular',
    xl: 'large'
  }[blockSize];
  return /*#__PURE__*/React.createElement(HeadingContainer, props, /*#__PURE__*/React.createElement(DefaultsProvider, {
    value: {
      tagSize
    }
  }, React.Children.toArray(children).map(child => typeof child === 'string' ? /*#__PURE__*/React.createElement(Text, {
    as: headingLevel,
    color: "var(--aui-on-surface)",
    size: size ?? fontSize[blockSize],
    weight: weight,
    key: child,
    lineHeight: lineHeight
  }, child) : child)));
};